import React from 'react'

import { Skeleton, Tooltip, Typography } from '@mui/material'
import { useCustomerRevealApiQuota } from 'features/customers/hooks/useCustomerRevealApiQuota'

import { hasRevealConfig } from '@albacross/types'

import { Dash } from 'components/_base'

import NotEnabled from './NotEnabled'
import UsageUnavailable from './UsageUnavailable'

const CustomerRevealApiCompaniesUsage = () => {
  const { data, isLoading, isError } = useCustomerRevealApiQuota()

  if (isError) return <UsageUnavailable />
  if (isLoading) return <Skeleton variant="text" width={85} />
  if (!hasRevealConfig(data)) return <NotEnabled />

  const count = data.uniqueIdentifiedCompaniesUsage

  // Management can be live against a proxy build that predates the field.
  if (count === undefined) {
    return (
      <Tooltip title="This version of the service does not report it">
        <span>
          <Dash />
        </span>
      </Tooltip>
    )
  }

  return (
    <Typography color="text.secondary" variant="caption">
      {count.toLocaleString()} this month
    </Typography>
  )
}

export default CustomerRevealApiCompaniesUsage
